import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import ConfirmModal from "../../../shared/components/modals/ConfirmModal/ConfirmModal";
import { getFeatureLockCopy } from "../../../shared/utils/planEntitlements";

export default function FeatureLockedModal({
  open,
  onClose,
  featureKey,
  isOrgOwner = false,
  title,
  description,
  billingCtaLabel,
  referenceLimit,
}) {
  const navigate = useNavigate();
  const copy = getFeatureLockCopy(featureKey, {
    title,
    description,
    billingCtaLabel,
    referenceLimit,
  });

  const handleConfirm = () => {
    if (!isOrgOwner) {
      onClose?.();
      return;
    }
    navigate("/settings?tab=billing");
    onClose?.();
  };

  const message = isOrgOwner
    ? copy.description
    : `${copy.description} Contact your organization owner to upgrade.`;

  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={copy.title}
      message={message}
      confirmLabel={isOrgOwner ? copy.billingCtaLabel || "Open Billing" : "Close"}
      cancelLabel={isOrgOwner ? "Not now" : "Dismiss"}
      confirmVariant="primary"
      Icon={Lock}
      closeIcon
    />
  );
}
